<template>
  <div class="personal-data">
    <div class="jiangli_top">
      <img @click="fanhui()" src="../../assets/images/licai/fanhui.png" />
      <p class="">设置</p>
    </div>
    <div class="person_top">
      <div class="person_top_list">
        <p class="person_top_list_left">支付密码</p>
        <p class="person_top_list_right">156161</p>
      </div>
      <div class="person_top_list">
        <p class="person_top_list_left">版本信息</p>
        <p class="person_top_list_right">2.35.20</p>
      </div>
      <div class="person_top_list">
        <p class="person_top_list_left">清理缓存</p>
        <p class="person_top_list_right">15.3k</p>
      </div>
    </div>
    <div
      class="logOut cart-color acea-row row-center-wrapper"
      @click="logout"
      v-if="!isWeixin"
    >
      退出登录
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { trim, apiUrl, isWeixin } from "@utils";

import { postUserEdit, getLogout, switchH5Login, getUser } from "@api/user";
import { clearAuthStatus } from "@libs/wechat";
import cookie from "@utils/store/cookie";
import store from "@/store";

export default {
  name: "PersonalData",
  components: {},
  data: function() {
    return {
      url: apiUrl("/upload/image"),
      headers: {
        "Authori-zation": "Bearer " + this.$store.state.app.token
      },
      avatar: "",
      isWeixin: false,
      currentAccounts: 0,
      switchUserInfo: [],
      userIndex: 0
    };
  },
  watch: {
    $route(n) {
      if (n.name === "PersonalData") this.$store.dispatch("USERINFO", true);
    }
  },
  computed: mapGetters(["userInfo"]),
  mounted: function() {
    this.avatar = this.userInfo.avatar;
    this.isWeixin = isWeixin();
    this.getUserInfo();
  },
  methods: {
    switchAccounts: function(index) {
      let that = this;
      this.userIndex = index;
      let userInfo = this.switchUserInfo[this.userIndex];
      if (this.switchUserInfo.length <= 1) return true;
      if (userInfo === undefined)
        return this.$dialog.toast({ mes: "切换的账号不存在" });
      if (userInfo.user_type === "h5") {
        switchH5Login()
          .then(({ data }) => {
            that.$dialog.loading.close();
            let expires_time = data.expires_time.substring(0, 19);
            expires_time = expires_time.replace(/-/g, "/");
            expires_time = new Date(expires_time).getTime() - 28800000;
            const datas = {
              token: data.token,
              expires_time: expires_time
            };
            store.commit("LOGIN", datas);
            that.$emit("changeswitch", false);
            location.reload();
          })
          .catch(err => {
            that.$dialog.loading.close();
            return that.$dialog.toast({ mes: err });
          });
      } else {
        cookie.set("loginType", "wechat", 60);
        this.$dialog.loading.close();
        this.$store.commit("LOGOUT");
        clearAuthStatus();
        this.$emit("changeswitch", false);
        location.reload();
      }
    },
    getUserInfo: function() {
      let that = this;
      getUser().then(res => {
        let switchUserInfo = res.data.switchUserInfo;
        for (let i = 0; i < switchUserInfo.length; i++) {
          if (switchUserInfo[i].uid == that.userInfo.uid) that.userIndex = i;
          if (
            !that.isWeixin &&
            switchUserInfo[i].user_type != "h5" &&
            switchUserInfo[i].phone === ""
          )
            switchUserInfo.splice(i, 1);
        }
        that.$set(this, "switchUserInfo", switchUserInfo);
      });
    },
    imageuploaded(res) {
      if (res.status !== 200)
        return this.$dialog.error(res.msg || "上传图片失败");
      if (this.switchUserInfo[this.userIndex] === undefined) return;
      this.$set(this.switchUserInfo[this.userIndex], "avatar", res.data.url);
    },

    submit: function() {
      let userInfo = this.switchUserInfo[this.userIndex];
      postUserEdit({
        nickname: trim(this.userInfo.nickname),
        avatar: userInfo.avatar
      }).then(res => {
        this.$store.dispatch("USERINFO", true);
        this.$dialog.success(res.msg);
        this.$router.go(-1);
      });
    },
    logout: function() {
      this.$dialog.confirm({
        mes: "确认退出登录?",
        opts: () => {
          getLogout()
            .then(res => {
              this.$store.commit("LOGOUT");
              clearAuthStatus();
              location.href = location.origin;
              console.log(res);
            })
            .catch(err => {
              console.log(err);
            });
        }
      });
    }
  }
};
</script>
<style scoped>
.person_top_list {
  display: flex;
  align-items: center;
}
.person_top_list_left {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 50px;
}
.person_top_list_right {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999;
  line-height: 50px;
  margin-left: auto;
}
.logOut {
  border: 0px !important;
  background-color: #2f365a !important;
  color: #fff !important;
  text-align: center;
}
.jiangli_top {
  width: 100%;
  height: 45px;
  line-height: 45px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px 15px;
}
.jiangli_top img {
  height: 30px;
  width: 30px;
  position: absolute;
  left: 0px;
}
.jiangli_top p {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333 !important;
  text-align: center;
}
</style>
